module.exports = __webpack_public_path__ + "static/media/ad.9baed0b4.svg";